import React from 'react';
import { TaraCard, TaraCardContent } from '../ui/TaraCard';

const TodayCard = ({ summary, score, icon, gradient = 'from-cosmic-100 to-sacred-100' }) => {
  return (
    <TaraCard className={`bg-gradient-to-br ${gradient} border-none shadow-sm`}>
      <TaraCardContent className="p-4">
        <div className="flex items-center justify-between">
          <div className="flex-1">
            <p className="text-sm text-stone-700 leading-relaxed">{summary}</p>
          </div>
          <div className="flex items-center gap-3 ml-4">
            <div className="text-center">
              <div className="text-2xl font-bold text-stone-900">{score}</div>
              <div className="text-xs text-stone-600">/ 10</div>
            </div>
            <div className="text-3xl">{icon}</div>
          </div>
        </div>
      </TaraCardContent>
    </TaraCard>
  );
};

export default TodayCard;